<template>
  <div class="mfr-container">
    <h6 style="padding: 0;">{{$t('map.fee2')}} <small>{{$t('map.multi_selection')}}</small></h6>
    <div class="mt-3 mb-2">
      <b-button v-for="(v,k,i) in $c.MF_FEE" variant="white" size="sm" :key="i"
                :pressed="checkFee(v)" @click="toggleFee(v)">{{k}}</b-button>
    </div>
    <!-- Trading -->
    <div v-if="checkFee($c.MF_FEE[$t('map.all')]) || checkFee($c.MF_FEE[$t('interest.trading')])">
      <h6 class="mt-5" style="padding: 0;">{{$t('interest.trading')}}
        <small class="price">
          {{trading[0]}} ~ {{(trading[1] == 100) ? $t('map.unlimited') : trading[1]}}
        </small>
      </h6>
      <div class="mt-3 mb-5 mr-3 ml-3">
        <vue-slider v-model="trading" :enable-cross="false" :min="0" :interval="5"
                  :max="100" :tooltip="'none'" :marks="marks">
          <template v-slot:mark="{pos, label}">
            <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
              |<br>{{ label }}
            </div>
          </template>
        </vue-slider>
      </div>
    </div>
    <!-- charter -->
    <div v-if="checkFee($c.MF_FEE[$t('map.all')]) || checkFee($c.MF_FEE[$t('interest.charter')])">
      <h6 class="mt-5">{{$t('interest.charter')}}
        <small class="price">
          {{charter[0]}} ~ {{(charter[1] == 100) ? $t('map.unlimited') : charter[1]}}
        </small>
      </h6>
      <div class="mt-3 mb-5 mr-3 ml-3">
        <vue-slider v-model="charter" :enable-cross="false" :min="0" :interval="5"
                  :max="100" :tooltip="'none'" :marks="marks">
          <template v-slot:mark="{pos, label}">
            <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
              |<br>{{ label }}
            </div>
          </template>
        </vue-slider>
      </div>
    </div>
    <!-- invest -->
    <div v-if="checkFee($c.MF_FEE[$t('map.all')]) || checkFee($c.MF_FEE[$t('interest.invest')])">
      <h6 class="mt-5">{{$t('interest.invest')}}
        <small class="price">
          {{invest[0]}} ~ {{(invest[1] == 100) ? $t('map.unlimited') : invest[1]}}
        </small>
      </h6>
      <div class="mt-3 mb-5 mr-3 ml-3">
        <vue-slider v-model="invest" :enable-cross="false" :min="0" :interval="5"
                  :max="100" :tooltip="'none'" :marks="marks">
          <template v-slot:mark="{pos, label}">
            <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
              |<br>{{ label }}
            </div>
          </template>
        </vue-slider>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MFR',
  data: function() {
    return {
      marks: {
        '0': {label: 0},
        '50': {label: 50},
        '100': {label: 100 +' '+ this.$t('map.more')},
      },
    };
  },
  computed: {
    trading: {
      get: function() {
        return [
          this.$store.getters.filter.fee_trading_min,
          this.$store.getters.filter.fee_trading_max,
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          fee_trading_min: v[0],
          fee_trading_max: v[1],
        });
      },
    },
    charter: {
      get: function() {
        return [
          this.$store.getters.filter.fee_charter_min,
          this.$store.getters.filter.fee_charter_max,
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          fee_charter_min: v[0],
          fee_charter_max: v[1],
        });
      },
    },
    invest: {
      get: function() {
        return [
          this.$store.getters.filter.fee_invest_min,
          this.$store.getters.filter.fee_invest_max,
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          fee_invest_min: v[0],
          fee_invest_max: v[1],
        });
      },
    },
  },
  methods: {
    checkFee: function(val) {
      if (val == '')
        return this.$store.getters.filter.fee_type == '';
      var flts = (this.$store.getters.filter.fee_type == '' ? [] :
                  this.$store.getters.filter.fee_type.split(','));
      return (flts.indexOf(val) != -1);
    },
    toggleFee: function(val) {
      if (val == '') {
        this.$store.commit('setFilter', {fee_type: ''});
        return;
      }
      var flts = (this.$store.getters.filter.fee_type == '' ? [] :
                  this.$store.getters.filter.fee_type.split(','));
      var idx = flts.indexOf(val);
      if (idx != -1)
        flts.splice(idx, 1);
      else
        flts.push(val);
      this.$store.commit('setFilter', {fee_type: flts.join(',')});
    },
  },
}
</script>

<style scoped lang="scss">
  @import '../../../assets/css/_vars.scss';
  h6 {
    font-size: $fs_22;
    font-family: $korean_gd_17_r;
    padding-top: 20px;
  }
  div.mfr-container {
    padding: 40px;
    background-color: white;
    width: 100%;
    margin: auto;
  }
  button {
    margin-right: 8px;
    font-size: $fs_20;
    font-family: $korean_gd_14_r;
    border-width: 0.5px;
    border-radius: 5px;
    border-color: #eeeeef;
    height: 50px;
    padding: .375rem .75rem;
  }
  h6>small {
    color: #ccc9c9;
    font-size: $fs_18;
    font-family: $korean_gd_13_r;
  }
  h6>small.price {
    color: $primary;
    float: right;
    font-size: $fs_20;
    font-family: $korean_gd_14_r;
  }
</style>



// WEBPACK FOOTER //
// src/components/controls/mf/MFR.vue